// src/preset/tiny.ts
import { HonoBase } from "../hono-base.js";
import { PatternRouter } from "../router/pattern-router/index.js";
var Hono = class extends HonoBase {
  constructor(options = {}) {
    super(options);
    this.router = new PatternRouter();
  }
};
export {
  Hono
};
